import { useEffect } from 'react';
import { useMutation } from 'react-query';
import { Row, Col, Image, Form, Input, Typography, Spin, message } from 'antd';
import EndPoints from '../../shared/endPoints/EndPoints.json';
import useHttpClient from '../../shared/sendRequest/useHttpClient';
import { useAuthContext } from '../../shared/context/auth-context';
import Img from '../../assets/btm logo.png';
import AuthCard from '../../components/AuthCard/AuthCard';
import { inputItem } from '../LoginFlow/Password/styles';
import NewPasswordFields from '../LoginFlow/Password/NewPasswordFields';
import PasswordSubmitButton from '../LoginFlow/Password/PasswordSubmitButton';
import { colPadding, image, imageWidth } from './styles';

const { Text } = Typography;

export default function Profile() {
  const [form] = Form.useForm();
  const { sendRequest } = useHttpClient();
  const { username, logout } = useAuthContext();

  const { mutate, status, isLoading } = useMutation(sendRequest, {
    onSuccess: data => {
      if (data) {
        message.success('Η καταχώρηση ήταν επιτυχής');
        logout();
      }
    }
  });

  useEffect(() => {
    if (status === 'loading') {
      message.loading();
    }
  }, [status]);

  const onFinish = values => {
    mutate({
      endpoint: EndPoints.USER.CHANGEPASSWORD,
      method: 'PUT',
      bodyData: values
    });
  };

  useEffect(() => {
    form.setFieldsValue({
      username
    });
  }, [form]);

  return (
    <Row justify="center" align="middle" style={{ flexDirection: 'column' }}>
      <Col>
        <Image style={image} src={Img} width={350} preview={false} />
      </Col>
      <Col xs={24} style={colPadding}>
        <Spin spinning={isLoading} size="large">
          <AuthCard
            title="Αλλαγή στοιχείων πρόσβασης"
            subtitle=""
            style={imageWidth}
            showImage={false}
          >
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              autoComplete="off"
            >
              <Form.Item
                label={<Text strong>Αριθμός Συμβολαίου</Text>}
                name="username"
              >
                <Input
                  disabled
                  style={{ ...inputItem, color: 'black' }}
                  size="large"
                />
              </Form.Item>
              <Form.Item name="newUsername" hidden>
                <Input />
              </Form.Item>
              <Form.Item
                label={<Text strong>Κωδικός πρόσβασης</Text>}
                name="password"
                rules={[
                  {
                    required: true,
                    message: 'Εισάγετε τον ισχύοντα κωδικό πρόσβασης'
                  }
                ]}
              >
                <Input.Password size="large" style={inputItem} />
              </Form.Item>
              <NewPasswordFields
                name="newPassword"
                label="Νέος κωδικός πρόσβασης"
                confirmLabel="Επιβεβαίωση νέου κωδικού πρόσβασης"
                requiredMessage="Παρακαλώ εισάγετε κωδικό πρόσβασης"
                confirmRequiredMessage="Παρακαλώ επιβεβαιώστε τον νέο κωδικό πρόσβασης"
              />
              <PasswordSubmitButton form={form} passwordName="newPassword">
                Αλλαγή
              </PasswordSubmitButton>
            </Form>
          </AuthCard>
        </Spin>
      </Col>
    </Row>
  );
}
